"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PhoneNumberType_Factory = /** @class */ (function () {
    function PhoneNumberType_Factory() {
    }
    PhoneNumberType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ContactInfoTypeCode: model.ContactInfoTypeCode,
            PhoneNumberType1: model.PhoneNumberType1,
            PhoneNumberTypeCode: model.PhoneNumberTypeCode,
        };
        return result;
    };
    PhoneNumberType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ContactInfoTypeCode: model.ContactInfoTypeCode,
            PhoneNumberType1: model.PhoneNumberType1,
            PhoneNumberTypeCode: model.PhoneNumberTypeCode,
        };
        return result;
    };
    return PhoneNumberType_Factory;
}());
exports.PhoneNumberType_Factory = PhoneNumberType_Factory;
